import * as pe from "react";
import at, { forwardRef as Vt, useContext as ot, createContext as Wt, useRef as jr, useState as zt, useEffect as Ut, useMemo as Bt, useImperativeHandle as qt, cloneElement as Ht } from "react";
import { css as V } from "@emotion/react";
import { getColor as dr, globalColor as Yr, illaPrefix as Lr, getColorShadow as Xt, applyBoxStyle as Gt } from "@illa-design/theme";
import { createIcon as rr } from "@illa-design/icon";
import { flip as Zt, offset as Jt, size as Kt, hide as Qt, useFloating as en, autoUpdate as rn, useInteractions as tn, useHover as nn, safePolygon as an, useClick as on, useFocus as sn, useRole as cn, useDismiss as un, useMergeRefs as fn, computePosition as ln, FloatingPortal as dn } from "@floating-ui/react";
import { motion as pn, AnimatePresence as vn } from "framer-motion";
var pr = { exports: {} }, Fe = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vr;
function hn() {
  if (Vr)
    return Fe;
  Vr = 1;
  var e = at, r = Symbol.for("react.element"), n = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(u, p, h) {
    var d, g = {}, R = null, A = null;
    h !== void 0 && (R = "" + h), p.key !== void 0 && (R = "" + p.key), p.ref !== void 0 && (A = p.ref);
    for (d in p)
      a.call(p, d) && !i.hasOwnProperty(d) && (g[d] = p[d]);
    if (u && u.defaultProps)
      for (d in p = u.defaultProps, p)
        g[d] === void 0 && (g[d] = p[d]);
    return { $$typeof: r, type: u, key: R, ref: A, props: g, _owner: o.current };
  }
  return Fe.Fragment = n, Fe.jsx = l, Fe.jsxs = l, Fe;
}
var je = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wr;
function mn() {
  return Wr || (Wr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = at, r = Symbol.for("react.element"), n = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), u = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), h = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), R = Symbol.for("react.lazy"), A = Symbol.for("react.offscreen"), k = Symbol.iterator, m = "@@iterator";
    function F(t) {
      if (t === null || typeof t != "object")
        return null;
      var s = k && t[k] || t[m];
      return typeof s == "function" ? s : null;
    }
    var x = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function b(t) {
      {
        for (var s = arguments.length, f = new Array(s > 1 ? s - 1 : 0), y = 1; y < s; y++)
          f[y - 1] = arguments[y];
        C("error", t, f);
      }
    }
    function C(t, s, f) {
      {
        var y = x.ReactDebugCurrentFrame, T = y.getStackAddendum();
        T !== "" && (s += "%s", f = f.concat([T]));
        var D = f.map(function(S) {
          return String(S);
        });
        D.unshift("Warning: " + s), Function.prototype.apply.call(console[t], console, D);
      }
    }
    var I = !1, c = !1, M = !1, _ = !1, K = !1, oe;
    oe = Symbol.for("react.module.reference");
    function Ee(t) {
      return !!(typeof t == "string" || typeof t == "function" || t === a || t === i || K || t === o || t === h || t === d || _ || t === A || I || c || M || typeof t == "object" && t !== null && (t.$$typeof === R || t.$$typeof === g || t.$$typeof === l || t.$$typeof === u || t.$$typeof === p || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      t.$$typeof === oe || t.getModuleId !== void 0));
    }
    function ke(t, s, f) {
      var y = t.displayName;
      if (y)
        return y;
      var T = s.displayName || s.name || "";
      return T !== "" ? f + "(" + T + ")" : f;
    }
    function xe(t) {
      return t.displayName || "Context";
    }
    function W(t) {
      if (t == null)
        return null;
      if (typeof t.tag == "number" && b("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof t == "function")
        return t.displayName || t.name || null;
      if (typeof t == "string")
        return t;
      switch (t) {
        case a:
          return "Fragment";
        case n:
          return "Portal";
        case i:
          return "Profiler";
        case o:
          return "StrictMode";
        case h:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case u:
            var s = t;
            return xe(s) + ".Consumer";
          case l:
            var f = t;
            return xe(f._context) + ".Provider";
          case p:
            return ke(t, t.render, "ForwardRef");
          case g:
            var y = t.displayName || null;
            return y !== null ? y : W(t.type) || "Memo";
          case R: {
            var T = t, D = T._payload, S = T._init;
            try {
              return W(S(D));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Z = Object.assign, le = 0, ie, se, ve, _e, me, Se, he;
    function Ce() {
    }
    Ce.__reactDisabledLog = !0;
    function Ae() {
      {
        if (le === 0) {
          ie = console.log, se = console.info, ve = console.warn, _e = console.error, me = console.group, Se = console.groupCollapsed, he = console.groupEnd;
          var t = {
            configurable: !0,
            enumerable: !0,
            value: Ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: t,
            log: t,
            warn: t,
            error: t,
            group: t,
            groupCollapsed: t,
            groupEnd: t
          });
        }
        le++;
      }
    }
    function Ie() {
      {
        if (le--, le === 0) {
          var t = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Z({}, t, {
              value: ie
            }),
            info: Z({}, t, {
              value: se
            }),
            warn: Z({}, t, {
              value: ve
            }),
            error: Z({}, t, {
              value: _e
            }),
            group: Z({}, t, {
              value: me
            }),
            groupCollapsed: Z({}, t, {
              value: Se
            }),
            groupEnd: Z({}, t, {
              value: he
            })
          });
        }
        le < 0 && b("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var ye = x.ReactCurrentDispatcher, ge;
    function q(t, s, f) {
      {
        if (ge === void 0)
          try {
            throw Error();
          } catch (T) {
            var y = T.stack.trim().match(/\n( *(at )?)/);
            ge = y && y[1] || "";
          }
        return `
` + ge + t;
      }
    }
    var ne = !1, H;
    {
      var De = typeof WeakMap == "function" ? WeakMap : Map;
      H = new De();
    }
    function v(t, s) {
      if (!t || ne)
        return "";
      {
        var f = H.get(t);
        if (f !== void 0)
          return f;
      }
      var y;
      ne = !0;
      var T = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var D;
      D = ye.current, ye.current = null, Ae();
      try {
        if (s) {
          var S = function() {
            throw Error();
          };
          if (Object.defineProperty(S.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(S, []);
            } catch (de) {
              y = de;
            }
            Reflect.construct(t, [], S);
          } else {
            try {
              S.call();
            } catch (de) {
              y = de;
            }
            t.call(S.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (de) {
            y = de;
          }
          t();
        }
      } catch (de) {
        if (de && y && typeof de.stack == "string") {
          for (var E = de.stack.split(`
`), X = y.stack.split(`
`), j = E.length - 1, Y = X.length - 1; j >= 1 && Y >= 0 && E[j] !== X[Y]; )
            Y--;
          for (; j >= 1 && Y >= 0; j--, Y--)
            if (E[j] !== X[Y]) {
              if (j !== 1 || Y !== 1)
                do
                  if (j--, Y--, Y < 0 || E[j] !== X[Y]) {
                    var re = `
` + E[j].replace(" at new ", " at ");
                    return t.displayName && re.includes("<anonymous>") && (re = re.replace("<anonymous>", t.displayName)), typeof t == "function" && H.set(t, re), re;
                  }
                while (j >= 1 && Y >= 0);
              break;
            }
        }
      } finally {
        ne = !1, ye.current = D, Ie(), Error.prepareStackTrace = T;
      }
      var Oe = t ? t.displayName || t.name : "", Fr = Oe ? q(Oe) : "";
      return typeof t == "function" && H.set(t, Fr), Fr;
    }
    function ce(t, s, f) {
      return v(t, !1);
    }
    function U(t) {
      var s = t.prototype;
      return !!(s && s.isReactComponent);
    }
    function Q(t, s, f) {
      if (t == null)
        return "";
      if (typeof t == "function")
        return v(t, U(t));
      if (typeof t == "string")
        return q(t);
      switch (t) {
        case h:
          return q("Suspense");
        case d:
          return q("SuspenseList");
      }
      if (typeof t == "object")
        switch (t.$$typeof) {
          case p:
            return ce(t.render);
          case g:
            return Q(t.type, s, f);
          case R: {
            var y = t, T = y._payload, D = y._init;
            try {
              return Q(D(T), s, f);
            } catch {
            }
          }
        }
      return "";
    }
    var Re = Object.prototype.hasOwnProperty, qe = {}, w = x.ReactDebugCurrentFrame;
    function be(t) {
      if (t) {
        var s = t._owner, f = Q(t.type, t._source, s ? s.type : null);
        w.setExtraStackFrame(f);
      } else
        w.setExtraStackFrame(null);
    }
    function wr(t, s, f, y, T) {
      {
        var D = Function.call.bind(Re);
        for (var S in t)
          if (D(t, S)) {
            var E = void 0;
            try {
              if (typeof t[S] != "function") {
                var X = Error((y || "React class") + ": " + f + " type `" + S + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof t[S] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw X.name = "Invariant Violation", X;
              }
              E = t[S](s, S, y, f, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (j) {
              E = j;
            }
            E && !(E instanceof Error) && (be(T), b("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", y || "React class", f, S, typeof E), be(null)), E instanceof Error && !(E.message in qe) && (qe[E.message] = !0, be(T), b("Failed %s type: %s", f, E.message), be(null));
          }
      }
    }
    var ir = Array.isArray;
    function we(t) {
      return ir(t);
    }
    function St(t) {
      {
        var s = typeof Symbol == "function" && Symbol.toStringTag, f = s && t[Symbol.toStringTag] || t.constructor.name || "Object";
        return f;
      }
    }
    function Ct(t) {
      try {
        return Tr(t), !1;
      } catch {
        return !0;
      }
    }
    function Tr(t) {
      return "" + t;
    }
    function Or(t) {
      if (Ct(t))
        return b("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", St(t)), Tr(t);
    }
    var Me = x.ReactCurrentOwner, Rt = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Pr, Nr, sr;
    sr = {};
    function wt(t) {
      if (Re.call(t, "ref")) {
        var s = Object.getOwnPropertyDescriptor(t, "ref").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.ref !== void 0;
    }
    function Tt(t) {
      if (Re.call(t, "key")) {
        var s = Object.getOwnPropertyDescriptor(t, "key").get;
        if (s && s.isReactWarning)
          return !1;
      }
      return t.key !== void 0;
    }
    function Ot(t, s) {
      if (typeof t.ref == "string" && Me.current && s && Me.current.stateNode !== s) {
        var f = W(Me.current.type);
        sr[f] || (b('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', W(Me.current.type), t.ref), sr[f] = !0);
      }
    }
    function Pt(t, s) {
      {
        var f = function() {
          Pr || (Pr = !0, b("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "key", {
          get: f,
          configurable: !0
        });
      }
    }
    function Nt(t, s) {
      {
        var f = function() {
          Nr || (Nr = !0, b("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", s));
        };
        f.isReactWarning = !0, Object.defineProperty(t, "ref", {
          get: f,
          configurable: !0
        });
      }
    }
    var $t = function(t, s, f, y, T, D, S) {
      var E = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: r,
        // Built-in properties that belong on the element
        type: t,
        key: s,
        ref: f,
        props: S,
        // Record the component responsible for creating this element.
        _owner: D
      };
      return E._store = {}, Object.defineProperty(E._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(E, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: y
      }), Object.defineProperty(E, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: T
      }), Object.freeze && (Object.freeze(E.props), Object.freeze(E)), E;
    };
    function kt(t, s, f, y, T) {
      {
        var D, S = {}, E = null, X = null;
        f !== void 0 && (Or(f), E = "" + f), Tt(s) && (Or(s.key), E = "" + s.key), wt(s) && (X = s.ref, Ot(s, T));
        for (D in s)
          Re.call(s, D) && !Rt.hasOwnProperty(D) && (S[D] = s[D]);
        if (t && t.defaultProps) {
          var j = t.defaultProps;
          for (D in j)
            S[D] === void 0 && (S[D] = j[D]);
        }
        if (E || X) {
          var Y = typeof t == "function" ? t.displayName || t.name || "Unknown" : t;
          E && Pt(S, Y), X && Nt(S, Y);
        }
        return $t(t, E, X, T, y, Me.current, S);
      }
    }
    var cr = x.ReactCurrentOwner, $r = x.ReactDebugCurrentFrame;
    function Te(t) {
      if (t) {
        var s = t._owner, f = Q(t.type, t._source, s ? s.type : null);
        $r.setExtraStackFrame(f);
      } else
        $r.setExtraStackFrame(null);
    }
    var ur;
    ur = !1;
    function fr(t) {
      return typeof t == "object" && t !== null && t.$$typeof === r;
    }
    function kr() {
      {
        if (cr.current) {
          var t = W(cr.current.type);
          if (t)
            return `

Check the render method of \`` + t + "`.";
        }
        return "";
      }
    }
    function At(t) {
      {
        if (t !== void 0) {
          var s = t.fileName.replace(/^.*[\\\/]/, ""), f = t.lineNumber;
          return `

Check your code at ` + s + ":" + f + ".";
        }
        return "";
      }
    }
    var Ar = {};
    function It(t) {
      {
        var s = kr();
        if (!s) {
          var f = typeof t == "string" ? t : t.displayName || t.name;
          f && (s = `

Check the top-level render call using <` + f + ">.");
        }
        return s;
      }
    }
    function Ir(t, s) {
      {
        if (!t._store || t._store.validated || t.key != null)
          return;
        t._store.validated = !0;
        var f = It(s);
        if (Ar[f])
          return;
        Ar[f] = !0;
        var y = "";
        t && t._owner && t._owner !== cr.current && (y = " It was passed a child from " + W(t._owner.type) + "."), Te(t), b('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', f, y), Te(null);
      }
    }
    function Dr(t, s) {
      {
        if (typeof t != "object")
          return;
        if (we(t))
          for (var f = 0; f < t.length; f++) {
            var y = t[f];
            fr(y) && Ir(y, s);
          }
        else if (fr(t))
          t._store && (t._store.validated = !0);
        else if (t) {
          var T = F(t);
          if (typeof T == "function" && T !== t.entries)
            for (var D = T.call(t), S; !(S = D.next()).done; )
              fr(S.value) && Ir(S.value, s);
        }
      }
    }
    function Dt(t) {
      {
        var s = t.type;
        if (s == null || typeof s == "string")
          return;
        var f;
        if (typeof s == "function")
          f = s.propTypes;
        else if (typeof s == "object" && (s.$$typeof === p || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        s.$$typeof === g))
          f = s.propTypes;
        else
          return;
        if (f) {
          var y = W(s);
          wr(f, t.props, "prop", y, t);
        } else if (s.PropTypes !== void 0 && !ur) {
          ur = !0;
          var T = W(s);
          b("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", T || "Unknown");
        }
        typeof s.getDefaultProps == "function" && !s.getDefaultProps.isReactClassApproved && b("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Mt(t) {
      {
        for (var s = Object.keys(t.props), f = 0; f < s.length; f++) {
          var y = s[f];
          if (y !== "children" && y !== "key") {
            Te(t), b("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", y), Te(null);
            break;
          }
        }
        t.ref !== null && (Te(t), b("Invalid attribute `ref` supplied to `React.Fragment`."), Te(null));
      }
    }
    function Mr(t, s, f, y, T, D) {
      {
        var S = Ee(t);
        if (!S) {
          var E = "";
          (t === void 0 || typeof t == "object" && t !== null && Object.keys(t).length === 0) && (E += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var X = At(T);
          X ? E += X : E += kr();
          var j;
          t === null ? j = "null" : we(t) ? j = "array" : t !== void 0 && t.$$typeof === r ? (j = "<" + (W(t.type) || "Unknown") + " />", E = " Did you accidentally export a JSX literal instead of a component?") : j = typeof t, b("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", j, E);
        }
        var Y = kt(t, s, f, T, D);
        if (Y == null)
          return Y;
        if (S) {
          var re = s.children;
          if (re !== void 0)
            if (y)
              if (we(re)) {
                for (var Oe = 0; Oe < re.length; Oe++)
                  Dr(re[Oe], t);
                Object.freeze && Object.freeze(re);
              } else
                b("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Dr(re, t);
        }
        return t === a ? Mt(Y) : Dt(Y), Y;
      }
    }
    function Ft(t, s, f) {
      return Mr(t, s, f, !0);
    }
    function jt(t, s, f) {
      return Mr(t, s, f, !1);
    }
    var Yt = jt, Lt = Ft;
    je.Fragment = a, je.jsx = Yt, je.jsxs = Lt;
  }()), je;
}
process.env.NODE_ENV === "production" ? pr.exports = hn() : pr.exports = mn();
var Ve = pr.exports;
function yn(e) {
  if (e.sheet)
    return e.sheet;
  for (var r = 0; r < document.styleSheets.length; r++)
    if (document.styleSheets[r].ownerNode === e)
      return document.styleSheets[r];
}
function gn(e) {
  var r = document.createElement("style");
  return r.setAttribute("data-emotion", e.key), e.nonce !== void 0 && r.setAttribute("nonce", e.nonce), r.appendChild(document.createTextNode("")), r.setAttribute("data-s", ""), r;
}
var bn = /* @__PURE__ */ function() {
  function e(n) {
    var a = this;
    this._insertTag = function(o) {
      var i;
      a.tags.length === 0 ? a.insertionPoint ? i = a.insertionPoint.nextSibling : a.prepend ? i = a.container.firstChild : i = a.before : i = a.tags[a.tags.length - 1].nextSibling, a.container.insertBefore(o, i), a.tags.push(o);
    }, this.isSpeedy = n.speedy === void 0 ? process.env.NODE_ENV === "production" : n.speedy, this.tags = [], this.ctr = 0, this.nonce = n.nonce, this.key = n.key, this.container = n.container, this.prepend = n.prepend, this.insertionPoint = n.insertionPoint, this.before = null;
  }
  var r = e.prototype;
  return r.hydrate = function(a) {
    a.forEach(this._insertTag);
  }, r.insert = function(a) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(gn(this));
    var o = this.tags[this.tags.length - 1];
    if (process.env.NODE_ENV !== "production") {
      var i = a.charCodeAt(0) === 64 && a.charCodeAt(1) === 105;
      i && this._alreadyInsertedOrderInsensitiveRule && console.error(`You're attempting to insert the following rule:
` + a + "\n\n`@import` rules must be before all other types of rules in a stylesheet but other rules have already been inserted. Please ensure that `@import` rules are before all other rules."), this._alreadyInsertedOrderInsensitiveRule = this._alreadyInsertedOrderInsensitiveRule || !i;
    }
    if (this.isSpeedy) {
      var l = yn(o);
      try {
        l.insertRule(a, l.cssRules.length);
      } catch (u) {
        process.env.NODE_ENV !== "production" && !/:(-moz-placeholder|-moz-focus-inner|-moz-focusring|-ms-input-placeholder|-moz-read-write|-moz-read-only|-ms-clear|-ms-expand|-ms-reveal){/.test(a) && console.error('There was a problem inserting the following rule: "' + a + '"', u);
      }
    } else
      o.appendChild(document.createTextNode(a));
    this.ctr++;
  }, r.flush = function() {
    this.tags.forEach(function(a) {
      return a.parentNode && a.parentNode.removeChild(a);
    }), this.tags = [], this.ctr = 0, process.env.NODE_ENV !== "production" && (this._alreadyInsertedOrderInsensitiveRule = !1);
  }, e;
}(), B = "-ms-", Qe = "-moz-", O = "-webkit-", br = "comm", Er = "rule", xr = "decl", En = "@import", it = "@keyframes", xn = "@layer", _n = Math.abs, tr = String.fromCharCode, Sn = Object.assign;
function Cn(e, r) {
  return z(e, 0) ^ 45 ? (((r << 2 ^ z(e, 0)) << 2 ^ z(e, 1)) << 2 ^ z(e, 2)) << 2 ^ z(e, 3) : 0;
}
function st(e) {
  return e.trim();
}
function Rn(e, r) {
  return (e = r.exec(e)) ? e[0] : e;
}
function P(e, r, n) {
  return e.replace(r, n);
}
function vr(e, r) {
  return e.indexOf(r);
}
function z(e, r) {
  return e.charCodeAt(r) | 0;
}
function We(e, r, n) {
  return e.slice(r, n);
}
function ue(e) {
  return e.length;
}
function _r(e) {
  return e.length;
}
function He(e, r) {
  return r.push(e), e;
}
function wn(e, r) {
  return e.map(r).join("");
}
var nr = 1, Ne = 1, ct = 0, J = 0, L = 0, $e = "";
function ar(e, r, n, a, o, i, l) {
  return { value: e, root: r, parent: n, type: a, props: o, children: i, line: nr, column: Ne, length: l, return: "" };
}
function Ye(e, r) {
  return Sn(ar("", null, null, "", null, null, 0), e, { length: -e.length }, r);
}
function Tn() {
  return L;
}
function On() {
  return L = J > 0 ? z($e, --J) : 0, Ne--, L === 10 && (Ne = 1, nr--), L;
}
function ee() {
  return L = J < ct ? z($e, J++) : 0, Ne++, L === 10 && (Ne = 1, nr++), L;
}
function fe() {
  return z($e, J);
}
function Ze() {
  return J;
}
function Be(e, r) {
  return We($e, e, r);
}
function ze(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function ut(e) {
  return nr = Ne = 1, ct = ue($e = e), J = 0, [];
}
function ft(e) {
  return $e = "", e;
}
function Je(e) {
  return st(Be(J - 1, hr(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function Pn(e) {
  for (; (L = fe()) && L < 33; )
    ee();
  return ze(e) > 2 || ze(L) > 3 ? "" : " ";
}
function Nn(e, r) {
  for (; --r && ee() && !(L < 48 || L > 102 || L > 57 && L < 65 || L > 70 && L < 97); )
    ;
  return Be(e, Ze() + (r < 6 && fe() == 32 && ee() == 32));
}
function hr(e) {
  for (; ee(); )
    switch (L) {
      case e:
        return J;
      case 34:
      case 39:
        e !== 34 && e !== 39 && hr(L);
        break;
      case 40:
        e === 41 && hr(e);
        break;
      case 92:
        ee();
        break;
    }
  return J;
}
function $n(e, r) {
  for (; ee() && e + L !== 47 + 10; )
    if (e + L === 42 + 42 && fe() === 47)
      break;
  return "/*" + Be(r, J - 1) + "*" + tr(e === 47 ? e : ee());
}
function kn(e) {
  for (; !ze(fe()); )
    ee();
  return Be(e, J);
}
function An(e) {
  return ft(Ke("", null, null, null, [""], e = ut(e), 0, [0], e));
}
function Ke(e, r, n, a, o, i, l, u, p) {
  for (var h = 0, d = 0, g = l, R = 0, A = 0, k = 0, m = 1, F = 1, x = 1, b = 0, C = "", I = o, c = i, M = a, _ = C; F; )
    switch (k = b, b = ee()) {
      case 40:
        if (k != 108 && z(_, g - 1) == 58) {
          vr(_ += P(Je(b), "&", "&\f"), "&\f") != -1 && (x = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        _ += Je(b);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        _ += Pn(k);
        break;
      case 92:
        _ += Nn(Ze() - 1, 7);
        continue;
      case 47:
        switch (fe()) {
          case 42:
          case 47:
            He(In($n(ee(), Ze()), r, n), p);
            break;
          default:
            _ += "/";
        }
        break;
      case 123 * m:
        u[h++] = ue(_) * x;
      case 125 * m:
      case 59:
      case 0:
        switch (b) {
          case 0:
          case 125:
            F = 0;
          case 59 + d:
            x == -1 && (_ = P(_, /\f/g, "")), A > 0 && ue(_) - g && He(A > 32 ? Ur(_ + ";", a, n, g - 1) : Ur(P(_, " ", "") + ";", a, n, g - 2), p);
            break;
          case 59:
            _ += ";";
          default:
            if (He(M = zr(_, r, n, h, d, o, u, C, I = [], c = [], g), i), b === 123)
              if (d === 0)
                Ke(_, r, M, M, I, i, g, u, c);
              else
                switch (R === 99 && z(_, 3) === 110 ? 100 : R) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Ke(e, M, M, a && He(zr(e, M, M, 0, 0, o, u, C, o, I = [], g), c), o, c, g, u, a ? I : c);
                    break;
                  default:
                    Ke(_, M, M, M, [""], c, 0, u, c);
                }
        }
        h = d = A = 0, m = x = 1, C = _ = "", g = l;
        break;
      case 58:
        g = 1 + ue(_), A = k;
      default:
        if (m < 1) {
          if (b == 123)
            --m;
          else if (b == 125 && m++ == 0 && On() == 125)
            continue;
        }
        switch (_ += tr(b), b * m) {
          case 38:
            x = d > 0 ? 1 : (_ += "\f", -1);
            break;
          case 44:
            u[h++] = (ue(_) - 1) * x, x = 1;
            break;
          case 64:
            fe() === 45 && (_ += Je(ee())), R = fe(), d = g = ue(C = _ += kn(Ze())), b++;
            break;
          case 45:
            k === 45 && ue(_) == 2 && (m = 0);
        }
    }
  return i;
}
function zr(e, r, n, a, o, i, l, u, p, h, d) {
  for (var g = o - 1, R = o === 0 ? i : [""], A = _r(R), k = 0, m = 0, F = 0; k < a; ++k)
    for (var x = 0, b = We(e, g + 1, g = _n(m = l[k])), C = e; x < A; ++x)
      (C = st(m > 0 ? R[x] + " " + b : P(b, /&\f/g, R[x]))) && (p[F++] = C);
  return ar(e, r, n, o === 0 ? Er : u, p, h, d);
}
function In(e, r, n) {
  return ar(e, r, n, br, tr(Tn()), We(e, 2, -2), 0);
}
function Ur(e, r, n, a) {
  return ar(e, r, n, xr, We(e, 0, a), We(e, a + 1, -1), a);
}
function Pe(e, r) {
  for (var n = "", a = _r(e), o = 0; o < a; o++)
    n += r(e[o], o, e, r) || "";
  return n;
}
function Dn(e, r, n, a) {
  switch (e.type) {
    case xn:
      if (e.children.length)
        break;
    case En:
    case xr:
      return e.return = e.return || e.value;
    case br:
      return "";
    case it:
      return e.return = e.value + "{" + Pe(e.children, a) + "}";
    case Er:
      e.value = e.props.join(",");
  }
  return ue(n = Pe(e.children, a)) ? e.return = e.value + "{" + n + "}" : "";
}
function Mn(e) {
  var r = _r(e);
  return function(n, a, o, i) {
    for (var l = "", u = 0; u < r; u++)
      l += e[u](n, a, o, i) || "";
    return l;
  };
}
function Fn(e) {
  return function(r) {
    r.root || (r = r.return) && e(r);
  };
}
function jn(e) {
  var r = /* @__PURE__ */ Object.create(null);
  return function(n) {
    return r[n] === void 0 && (r[n] = e(n)), r[n];
  };
}
var Yn = function(r, n, a) {
  for (var o = 0, i = 0; o = i, i = fe(), o === 38 && i === 12 && (n[a] = 1), !ze(i); )
    ee();
  return Be(r, J);
}, Ln = function(r, n) {
  var a = -1, o = 44;
  do
    switch (ze(o)) {
      case 0:
        o === 38 && fe() === 12 && (n[a] = 1), r[a] += Yn(J - 1, n, a);
        break;
      case 2:
        r[a] += Je(o);
        break;
      case 4:
        if (o === 44) {
          r[++a] = fe() === 58 ? "&\f" : "", n[a] = r[a].length;
          break;
        }
      default:
        r[a] += tr(o);
    }
  while (o = ee());
  return r;
}, Vn = function(r, n) {
  return ft(Ln(ut(r), n));
}, Br = /* @__PURE__ */ new WeakMap(), Wn = function(r) {
  if (!(r.type !== "rule" || !r.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  r.length < 1)) {
    for (var n = r.value, a = r.parent, o = r.column === a.column && r.line === a.line; a.type !== "rule"; )
      if (a = a.parent, !a)
        return;
    if (!(r.props.length === 1 && n.charCodeAt(0) !== 58 && !Br.get(a)) && !o) {
      Br.set(r, !0);
      for (var i = [], l = Vn(n, i), u = a.props, p = 0, h = 0; p < l.length; p++)
        for (var d = 0; d < u.length; d++, h++)
          r.props[h] = i[p] ? l[p].replace(/&\f/g, u[d]) : u[d] + " " + l[p];
    }
  }
}, zn = function(r) {
  if (r.type === "decl") {
    var n = r.value;
    // charcode for l
    n.charCodeAt(0) === 108 && // charcode for b
    n.charCodeAt(2) === 98 && (r.return = "", r.value = "");
  }
}, Un = "emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason", Bn = function(r) {
  return r.type === "comm" && r.children.indexOf(Un) > -1;
}, qn = function(r) {
  return function(n, a, o) {
    if (!(n.type !== "rule" || r.compat)) {
      var i = n.value.match(/(:first|:nth|:nth-last)-child/g);
      if (i) {
        for (var l = !!n.parent, u = l ? n.parent.children : (
          // global rule at the root level
          o
        ), p = u.length - 1; p >= 0; p--) {
          var h = u[p];
          if (h.line < n.line)
            break;
          if (h.column < n.column) {
            if (Bn(h))
              return;
            break;
          }
        }
        i.forEach(function(d) {
          console.error('The pseudo class "' + d + '" is potentially unsafe when doing server-side rendering. Try changing it to "' + d.split("-child")[0] + '-of-type".');
        });
      }
    }
  };
}, lt = function(r) {
  return r.type.charCodeAt(1) === 105 && r.type.charCodeAt(0) === 64;
}, Hn = function(r, n) {
  for (var a = r - 1; a >= 0; a--)
    if (!lt(n[a]))
      return !0;
  return !1;
}, qr = function(r) {
  r.type = "", r.value = "", r.return = "", r.children = "", r.props = "";
}, Xn = function(r, n, a) {
  lt(r) && (r.parent ? (console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles."), qr(r)) : Hn(n, a) && (console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules."), qr(r)));
};
function dt(e, r) {
  switch (Cn(e, r)) {
    case 5103:
      return O + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return O + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return O + e + Qe + e + B + e + e;
    case 6828:
    case 4268:
      return O + e + B + e + e;
    case 6165:
      return O + e + B + "flex-" + e + e;
    case 5187:
      return O + e + P(e, /(\w+).+(:[^]+)/, O + "box-$1$2" + B + "flex-$1$2") + e;
    case 5443:
      return O + e + B + "flex-item-" + P(e, /flex-|-self/, "") + e;
    case 4675:
      return O + e + B + "flex-line-pack" + P(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return O + e + B + P(e, "shrink", "negative") + e;
    case 5292:
      return O + e + B + P(e, "basis", "preferred-size") + e;
    case 6060:
      return O + "box-" + P(e, "-grow", "") + O + e + B + P(e, "grow", "positive") + e;
    case 4554:
      return O + P(e, /([^-])(transform)/g, "$1" + O + "$2") + e;
    case 6187:
      return P(P(P(e, /(zoom-|grab)/, O + "$1"), /(image-set)/, O + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return P(e, /(image-set\([^]*)/, O + "$1$`$1");
    case 4968:
      return P(P(e, /(.+:)(flex-)?(.*)/, O + "box-pack:$3" + B + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + O + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return P(e, /(.+)-inline(.+)/, O + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (ue(e) - 1 - r > 6)
        switch (z(e, r + 1)) {
          case 109:
            if (z(e, r + 4) !== 45)
              break;
          case 102:
            return P(e, /(.+:)(.+)-([^]+)/, "$1" + O + "$2-$3$1" + Qe + (z(e, r + 3) == 108 ? "$3" : "$2-$3")) + e;
          case 115:
            return ~vr(e, "stretch") ? dt(P(e, "stretch", "fill-available"), r) + e : e;
        }
      break;
    case 4949:
      if (z(e, r + 1) !== 115)
        break;
    case 6444:
      switch (z(e, ue(e) - 3 - (~vr(e, "!important") && 10))) {
        case 107:
          return P(e, ":", ":" + O) + e;
        case 101:
          return P(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + O + (z(e, 14) === 45 ? "inline-" : "") + "box$3$1" + O + "$2$3$1" + B + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (z(e, r + 11)) {
        case 114:
          return O + e + B + P(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return O + e + B + P(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return O + e + B + P(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return O + e + B + e + e;
  }
  return e;
}
var Gn = function(r, n, a, o) {
  if (r.length > -1 && !r.return)
    switch (r.type) {
      case xr:
        r.return = dt(r.value, r.length);
        break;
      case it:
        return Pe([Ye(r, {
          value: P(r.value, "@", "@" + O)
        })], o);
      case Er:
        if (r.length)
          return wn(r.props, function(i) {
            switch (Rn(i, /(::plac\w+|:read-\w+)/)) {
              case ":read-only":
              case ":read-write":
                return Pe([Ye(r, {
                  props: [P(i, /:(read-\w+)/, ":" + Qe + "$1")]
                })], o);
              case "::placeholder":
                return Pe([Ye(r, {
                  props: [P(i, /:(plac\w+)/, ":" + O + "input-$1")]
                }), Ye(r, {
                  props: [P(i, /:(plac\w+)/, ":" + Qe + "$1")]
                }), Ye(r, {
                  props: [P(i, /:(plac\w+)/, B + "input-$1")]
                })], o);
            }
            return "";
          });
    }
}, Zn = [Gn], Jn = function(r) {
  var n = r.key;
  if (process.env.NODE_ENV !== "production" && !n)
    throw new Error(`You have to configure \`key\` for your cache. Please make sure it's unique (and not equal to 'css') as it's used for linking styles to your cache.
If multiple caches share the same key they might "fight" for each other's style elements.`);
  if (n === "css") {
    var a = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(a, function(m) {
      var F = m.getAttribute("data-emotion");
      F.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
    });
  }
  var o = r.stylisPlugins || Zn;
  if (process.env.NODE_ENV !== "production" && /[^a-z-]/.test(n))
    throw new Error('Emotion key must only contain lower case alphabetical characters and - but "' + n + '" was passed');
  var i = {}, l, u = [];
  l = r.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + n + ' "]'),
    function(m) {
      for (var F = m.getAttribute("data-emotion").split(" "), x = 1; x < F.length; x++)
        i[F[x]] = !0;
      u.push(m);
    }
  );
  var p, h = [Wn, zn];
  process.env.NODE_ENV !== "production" && h.push(qn({
    get compat() {
      return k.compat;
    }
  }), Xn);
  {
    var d, g = [Dn, process.env.NODE_ENV !== "production" ? function(m) {
      m.root || (m.return ? d.insert(m.return) : m.value && m.type !== br && d.insert(m.value + "{}"));
    } : Fn(function(m) {
      d.insert(m);
    })], R = Mn(h.concat(o, g)), A = function(F) {
      return Pe(An(F), R);
    };
    p = function(F, x, b, C) {
      d = b, process.env.NODE_ENV !== "production" && x.map !== void 0 && (d = {
        insert: function(c) {
          b.insert(c + x.map);
        }
      }), A(F ? F + "{" + x.styles + "}" : x.styles), C && (k.inserted[x.name] = !0);
    };
  }
  var k = {
    key: n,
    sheet: new bn({
      key: n,
      container: l,
      nonce: r.nonce,
      speedy: r.speedy,
      prepend: r.prepend,
      insertionPoint: r.insertionPoint
    }),
    nonce: r.nonce,
    inserted: i,
    registered: {},
    insert: p
  };
  return k.sheet.hydrate(u), k;
}, mr = { exports: {} }, N = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Hr;
function Kn() {
  if (Hr)
    return N;
  Hr = 1;
  var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, k = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, F = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
  function C(c) {
    if (typeof c == "object" && c !== null) {
      var M = c.$$typeof;
      switch (M) {
        case r:
          switch (c = c.type, c) {
            case p:
            case h:
            case a:
            case i:
            case o:
            case g:
              return c;
            default:
              switch (c = c && c.$$typeof, c) {
                case u:
                case d:
                case k:
                case A:
                case l:
                  return c;
                default:
                  return M;
              }
          }
        case n:
          return M;
      }
    }
  }
  function I(c) {
    return C(c) === h;
  }
  return N.AsyncMode = p, N.ConcurrentMode = h, N.ContextConsumer = u, N.ContextProvider = l, N.Element = r, N.ForwardRef = d, N.Fragment = a, N.Lazy = k, N.Memo = A, N.Portal = n, N.Profiler = i, N.StrictMode = o, N.Suspense = g, N.isAsyncMode = function(c) {
    return I(c) || C(c) === p;
  }, N.isConcurrentMode = I, N.isContextConsumer = function(c) {
    return C(c) === u;
  }, N.isContextProvider = function(c) {
    return C(c) === l;
  }, N.isElement = function(c) {
    return typeof c == "object" && c !== null && c.$$typeof === r;
  }, N.isForwardRef = function(c) {
    return C(c) === d;
  }, N.isFragment = function(c) {
    return C(c) === a;
  }, N.isLazy = function(c) {
    return C(c) === k;
  }, N.isMemo = function(c) {
    return C(c) === A;
  }, N.isPortal = function(c) {
    return C(c) === n;
  }, N.isProfiler = function(c) {
    return C(c) === i;
  }, N.isStrictMode = function(c) {
    return C(c) === o;
  }, N.isSuspense = function(c) {
    return C(c) === g;
  }, N.isValidElementType = function(c) {
    return typeof c == "string" || typeof c == "function" || c === a || c === h || c === i || c === o || c === g || c === R || typeof c == "object" && c !== null && (c.$$typeof === k || c.$$typeof === A || c.$$typeof === l || c.$$typeof === u || c.$$typeof === d || c.$$typeof === F || c.$$typeof === x || c.$$typeof === b || c.$$typeof === m);
  }, N.typeOf = C, N;
}
var $ = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xr;
function Qn() {
  return Xr || (Xr = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, r = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, a = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, l = e ? Symbol.for("react.provider") : 60109, u = e ? Symbol.for("react.context") : 60110, p = e ? Symbol.for("react.async_mode") : 60111, h = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, g = e ? Symbol.for("react.suspense") : 60113, R = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, k = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, F = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, b = e ? Symbol.for("react.scope") : 60119;
    function C(v) {
      return typeof v == "string" || typeof v == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      v === a || v === h || v === i || v === o || v === g || v === R || typeof v == "object" && v !== null && (v.$$typeof === k || v.$$typeof === A || v.$$typeof === l || v.$$typeof === u || v.$$typeof === d || v.$$typeof === F || v.$$typeof === x || v.$$typeof === b || v.$$typeof === m);
    }
    function I(v) {
      if (typeof v == "object" && v !== null) {
        var ce = v.$$typeof;
        switch (ce) {
          case r:
            var U = v.type;
            switch (U) {
              case p:
              case h:
              case a:
              case i:
              case o:
              case g:
                return U;
              default:
                var Q = U && U.$$typeof;
                switch (Q) {
                  case u:
                  case d:
                  case k:
                  case A:
                  case l:
                    return Q;
                  default:
                    return ce;
                }
            }
          case n:
            return ce;
        }
      }
    }
    var c = p, M = h, _ = u, K = l, oe = r, Ee = d, ke = a, xe = k, W = A, Z = n, le = i, ie = o, se = g, ve = !1;
    function _e(v) {
      return ve || (ve = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), me(v) || I(v) === p;
    }
    function me(v) {
      return I(v) === h;
    }
    function Se(v) {
      return I(v) === u;
    }
    function he(v) {
      return I(v) === l;
    }
    function Ce(v) {
      return typeof v == "object" && v !== null && v.$$typeof === r;
    }
    function Ae(v) {
      return I(v) === d;
    }
    function Ie(v) {
      return I(v) === a;
    }
    function ye(v) {
      return I(v) === k;
    }
    function ge(v) {
      return I(v) === A;
    }
    function q(v) {
      return I(v) === n;
    }
    function ne(v) {
      return I(v) === i;
    }
    function H(v) {
      return I(v) === o;
    }
    function De(v) {
      return I(v) === g;
    }
    $.AsyncMode = c, $.ConcurrentMode = M, $.ContextConsumer = _, $.ContextProvider = K, $.Element = oe, $.ForwardRef = Ee, $.Fragment = ke, $.Lazy = xe, $.Memo = W, $.Portal = Z, $.Profiler = le, $.StrictMode = ie, $.Suspense = se, $.isAsyncMode = _e, $.isConcurrentMode = me, $.isContextConsumer = Se, $.isContextProvider = he, $.isElement = Ce, $.isForwardRef = Ae, $.isFragment = Ie, $.isLazy = ye, $.isMemo = ge, $.isPortal = q, $.isProfiler = ne, $.isStrictMode = H, $.isSuspense = De, $.isValidElementType = C, $.typeOf = I;
  }()), $;
}
process.env.NODE_ENV === "production" ? mr.exports = Kn() : mr.exports = Qn();
var ea = mr.exports, pt = ea, ra = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, ta = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, vt = {};
vt[pt.ForwardRef] = ra;
vt[pt.Memo] = ta;
var na = !0;
function aa(e, r, n) {
  var a = "";
  return n.split(" ").forEach(function(o) {
    e[o] !== void 0 ? r.push(e[o] + ";") : a += o + " ";
  }), a;
}
var ht = function(r, n, a) {
  var o = r.key + "-" + n.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (a === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  na === !1) && r.registered[o] === void 0 && (r.registered[o] = n.styles);
}, oa = function(r, n, a) {
  ht(r, n, a);
  var o = r.key + "-" + n.name;
  if (r.inserted[n.name] === void 0) {
    var i = n;
    do
      r.insert(n === i ? "." + o : "", i, r.sheet, !0), i = i.next;
    while (i !== void 0);
  }
};
function ia(e) {
  for (var r = 0, n, a = 0, o = e.length; o >= 4; ++a, o -= 4)
    n = e.charCodeAt(a) & 255 | (e.charCodeAt(++a) & 255) << 8 | (e.charCodeAt(++a) & 255) << 16 | (e.charCodeAt(++a) & 255) << 24, n = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16), n ^= /* k >>> r: */
    n >>> 24, r = /* Math.imul(k, m): */
    (n & 65535) * 1540483477 + ((n >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      r ^= (e.charCodeAt(a + 2) & 255) << 16;
    case 2:
      r ^= (e.charCodeAt(a + 1) & 255) << 8;
    case 1:
      r ^= e.charCodeAt(a) & 255, r = /* Math.imul(h, m): */
      (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16);
  }
  return r ^= r >>> 13, r = /* Math.imul(h, m): */
  (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), ((r ^ r >>> 15) >>> 0).toString(36);
}
var sa = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Gr = `You have illegal escape sequence in your template literal, most likely inside content's property value.
Because you write your CSS inside a JavaScript string you actually have to do double escaping, so for example "content: '\\00d7';" should become "content: '\\\\00d7';".
You can read more about this here:
https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences`, ca = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).", ua = /[A-Z]|^ms/g, mt = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Sr = function(r) {
  return r.charCodeAt(1) === 45;
}, Zr = function(r) {
  return r != null && typeof r != "boolean";
}, lr = /* @__PURE__ */ jn(function(e) {
  return Sr(e) ? e : e.replace(ua, "-$&").toLowerCase();
}), er = function(r, n) {
  switch (r) {
    case "animation":
    case "animationName":
      if (typeof n == "string")
        return n.replace(mt, function(a, o, i) {
          return ae = {
            name: o,
            styles: i,
            next: ae
          }, o;
        });
  }
  return sa[r] !== 1 && !Sr(r) && typeof n == "number" && n !== 0 ? n + "px" : n;
};
if (process.env.NODE_ENV !== "production") {
  var fa = /(var|attr|counters?|url|element|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/, la = ["normal", "none", "initial", "inherit", "unset"], da = er, pa = /^-ms-/, va = /-(.)/g, Jr = {};
  er = function(r, n) {
    if (r === "content" && (typeof n != "string" || la.indexOf(n) === -1 && !fa.test(n) && (n.charAt(0) !== n.charAt(n.length - 1) || n.charAt(0) !== '"' && n.charAt(0) !== "'")))
      throw new Error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + n + "\"'`");
    var a = da(r, n);
    return a !== "" && !Sr(r) && r.indexOf("-") !== -1 && Jr[r] === void 0 && (Jr[r] = !0, console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + r.replace(pa, "ms-").replace(va, function(o, i) {
      return i.toUpperCase();
    }) + "?")), a;
  };
}
var yt = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function Ue(e, r, n) {
  if (n == null)
    return "";
  if (n.__emotion_styles !== void 0) {
    if (process.env.NODE_ENV !== "production" && n.toString() === "NO_COMPONENT_SELECTOR")
      throw new Error(yt);
    return n;
  }
  switch (typeof n) {
    case "boolean":
      return "";
    case "object": {
      if (n.anim === 1)
        return ae = {
          name: n.name,
          styles: n.styles,
          next: ae
        }, n.name;
      if (n.styles !== void 0) {
        var a = n.next;
        if (a !== void 0)
          for (; a !== void 0; )
            ae = {
              name: a.name,
              styles: a.styles,
              next: ae
            }, a = a.next;
        var o = n.styles + ";";
        return process.env.NODE_ENV !== "production" && n.map !== void 0 && (o += n.map), o;
      }
      return ha(e, r, n);
    }
    case "function": {
      if (e !== void 0) {
        var i = ae, l = n(e);
        return ae = i, Ue(e, r, l);
      } else
        process.env.NODE_ENV !== "production" && console.error("Functions that are interpolated in css calls will be stringified.\nIf you want to have a css call based on props, create a function that returns a css call like this\nlet dynamicStyle = (props) => css`color: ${props.color}`\nIt can be called directly with props or interpolated in a styled call like this\nlet SomeComponent = styled('div')`${dynamicStyle}`");
      break;
    }
    case "string":
      if (process.env.NODE_ENV !== "production") {
        var u = [], p = n.replace(mt, function(d, g, R) {
          var A = "animation" + u.length;
          return u.push("const " + A + " = keyframes`" + R.replace(/^@keyframes animation-\w+/, "") + "`"), "${" + A + "}";
        });
        u.length && console.error("`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\nInstead of doing this:\n\n" + [].concat(u, ["`" + p + "`"]).join(`
`) + `

You should wrap it with \`css\` like this:

` + ("css`" + p + "`"));
      }
      break;
  }
  if (r == null)
    return n;
  var h = r[n];
  return h !== void 0 ? h : n;
}
function ha(e, r, n) {
  var a = "";
  if (Array.isArray(n))
    for (var o = 0; o < n.length; o++)
      a += Ue(e, r, n[o]) + ";";
  else
    for (var i in n) {
      var l = n[i];
      if (typeof l != "object")
        r != null && r[l] !== void 0 ? a += i + "{" + r[l] + "}" : Zr(l) && (a += lr(i) + ":" + er(i, l) + ";");
      else {
        if (i === "NO_COMPONENT_SELECTOR" && process.env.NODE_ENV !== "production")
          throw new Error(yt);
        if (Array.isArray(l) && typeof l[0] == "string" && (r == null || r[l[0]] === void 0))
          for (var u = 0; u < l.length; u++)
            Zr(l[u]) && (a += lr(i) + ":" + er(i, l[u]) + ";");
        else {
          var p = Ue(e, r, l);
          switch (i) {
            case "animation":
            case "animationName": {
              a += lr(i) + ":" + p + ";";
              break;
            }
            default:
              process.env.NODE_ENV !== "production" && i === "undefined" && console.error(ca), a += i + "{" + p + "}";
          }
        }
      }
    }
  return a;
}
var Kr = /label:\s*([^\s;\n{]+)\s*(;|$)/g, gt;
process.env.NODE_ENV !== "production" && (gt = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//g);
var ae, Qr = function(r, n, a) {
  if (r.length === 1 && typeof r[0] == "object" && r[0] !== null && r[0].styles !== void 0)
    return r[0];
  var o = !0, i = "";
  ae = void 0;
  var l = r[0];
  l == null || l.raw === void 0 ? (o = !1, i += Ue(a, n, l)) : (process.env.NODE_ENV !== "production" && l[0] === void 0 && console.error(Gr), i += l[0]);
  for (var u = 1; u < r.length; u++)
    i += Ue(a, n, r[u]), o && (process.env.NODE_ENV !== "production" && l[u] === void 0 && console.error(Gr), i += l[u]);
  var p;
  process.env.NODE_ENV !== "production" && (i = i.replace(gt, function(R) {
    return p = R, "";
  })), Kr.lastIndex = 0;
  for (var h = "", d; (d = Kr.exec(i)) !== null; )
    h += "-" + // $FlowFixMe we know it's not null
    d[1];
  var g = ia(i) + h;
  return process.env.NODE_ENV !== "production" ? {
    name: g,
    styles: i,
    map: p,
    next: ae,
    toString: function() {
      return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
  } : {
    name: g,
    styles: i,
    next: ae
  };
}, ma = function(r) {
  return r();
}, ya = pe["useInsertionEffect"] ? pe["useInsertionEffect"] : !1, ga = ya || ma, or = {}.hasOwnProperty, Cr = /* @__PURE__ */ pe.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Jn({
    key: "css"
  }) : null
);
process.env.NODE_ENV !== "production" && (Cr.displayName = "EmotionCacheContext");
Cr.Provider;
var ba = function(r) {
  return /* @__PURE__ */ Vt(function(n, a) {
    var o = ot(Cr);
    return r(n, o, a);
  });
}, bt = /* @__PURE__ */ pe.createContext({});
process.env.NODE_ENV !== "production" && (bt.displayName = "EmotionThemeContext");
var et = function(r) {
  var n = r.split(".");
  return n[n.length - 1];
}, Ea = function(r) {
  var n = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(r);
  if (n || (n = /^([A-Za-z0-9$.]+)@/.exec(r), n))
    return et(n[1]);
}, xa = /* @__PURE__ */ new Set(["renderWithHooks", "processChild", "finishClassComponent", "renderToString"]), _a = function(r) {
  return r.replace(/\$/g, "-");
}, Sa = function(r) {
  if (r)
    for (var n = r.split(`
`), a = 0; a < n.length; a++) {
      var o = Ea(n[a]);
      if (o) {
        if (xa.has(o))
          break;
        if (/^[A-Z]/.test(o))
          return _a(o);
      }
    }
}, yr = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", gr = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__", Et = function(r, n) {
  if (process.env.NODE_ENV !== "production" && typeof n.css == "string" && // check if there is a css declaration
  n.css.indexOf(":") !== -1)
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/react' like this: css`" + n.css + "`");
  var a = {};
  for (var o in n)
    or.call(n, o) && (a[o] = n[o]);
  if (a[yr] = r, process.env.NODE_ENV !== "production" && n.css && (typeof n.css != "object" || typeof n.css.name != "string" || n.css.name.indexOf("-") === -1)) {
    var i = Sa(new Error().stack);
    i && (a[gr] = i);
  }
  return a;
}, Ca = function(r) {
  var n = r.cache, a = r.serialized, o = r.isStringTag;
  return ht(n, a, o), ga(function() {
    return oa(n, a, o);
  }), null;
}, xt = /* @__PURE__ */ ba(function(e, r, n) {
  var a = e.css;
  typeof a == "string" && r.registered[a] !== void 0 && (a = r.registered[a]);
  var o = e[yr], i = [a], l = "";
  typeof e.className == "string" ? l = aa(r.registered, i, e.className) : e.className != null && (l = e.className + " ");
  var u = Qr(i, void 0, pe.useContext(bt));
  if (process.env.NODE_ENV !== "production" && u.name.indexOf("-") === -1) {
    var p = e[gr];
    p && (u = Qr([u, "label:" + p + ";"]));
  }
  l += r.key + "-" + u.name;
  var h = {};
  for (var d in e)
    or.call(e, d) && d !== "css" && d !== yr && (process.env.NODE_ENV === "production" || d !== gr) && (h[d] = e[d]);
  return h.ref = n, h.className = l, /* @__PURE__ */ pe.createElement(pe.Fragment, null, /* @__PURE__ */ pe.createElement(Ca, {
    cache: r,
    serialized: u,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ pe.createElement(o, h));
});
process.env.NODE_ENV !== "production" && (xt.displayName = "EmotionCssPropInternal");
var _t = xt, rt = Ve.Fragment;
function G(e, r, n) {
  return or.call(r, "css") ? Ve.jsx(_t, Et(e, r), n) : Ve.jsx(e, r, n);
}
function Le(e, r, n) {
  return or.call(r, "css") ? Ve.jsxs(_t, Et(e, r), n) : Ve.jsxs(e, r, n);
}
function te(e, r, n, a) {
  let o, i;
  return n ? (o = 0, i = 0) : a ? (o = 0.9, i = 1) : (o = 1, i = 0.9), {
    initial: {
      scaleY: i,
      scaleX: o,
      opacity: 0,
      originX: e,
      originY: r
    },
    animate: {
      scaleX: 1,
      scaleY: 1,
      opacity: 1,
      transition: {
        opacity: { duration: 0.15, ease: "easeInOut" },
        scaleX: { duration: 0.15, ease: "easeInOut" },
        scaleY: { duration: 0.15, ease: "easeInOut" }
      }
    },
    exit: {
      scaleY: i,
      scaleX: o,
      opacity: 0,
      transition: {
        duration: 0.2,
        opacity: { duration: 0.15, ease: "easeInOut" },
        scaleX: { duration: 0.15, ease: "easeInOut" },
        scaleY: { duration: 0.15, ease: "easeInOut" }
      }
    }
  };
}
function Ra(e) {
  return V`
    display: inline-flex;
    pointer-events: auto;
    width: ${e ? "100%" : "auto"};
  `;
}
function Xe(e, r, n, a, o) {
  const i = e == "white" ? dr(e, "01") : dr(e, "02"), l = e == "white" ? Yr(`--${Lr}-grayBlue-02`) : Yr(`--${Lr}-white-01`);
  let p = V`
    padding: 8px ${"12px"};
  `;
  n && (p = V``);
  let h = V`
    box-shadow: ${Xt("blackAlpha", "01")};
  `;
  a && (h = V``);
  let d = V``;
  return o && (d = V`
      max-width: unset;
    `), V`
    background-color: ${i};
    color: ${l};
    box-sizing: border-box;
    text-align: left;
    max-width: ${r};
    border-radius: 8px;
    font-size: 14px;
    ${p};
    ${h};
    ${d}
  `;
}
function Ge(e, r) {
  const n = dr(e, "02"), a = V`
    color: ${n};
  `;
  let o;
  switch (r) {
    case "top":
    case "bottom":
    case "left":
    case "right":
      o = V`
        align-self: center;
      `;
      break;
    case "top-start":
    case "bottom-start":
      o = V`
        align-self: start;
        margin-left: 12px;
      `;
      break;
    case "top-end":
    case "bottom-end":
      o = V`
        align-self: end;
        margin-right: 12px;
      `;
      break;
    case "left-start":
    case "right-start":
      o = V`
        align-self: start;
        margin-top: 12px;
      `;
      break;
    case "left-end":
    case "right-end":
      o = V`
        align-self: end;
        margin-bottom: 12px;
      `;
      break;
  }
  return V`
    ${a};
    ${o};
  `;
}
function wa(e, r) {
  const n = e == "left" || e == "left-start" || e == "left-end" || e == "right" || e == "right-start" || e == "right-end";
  switch (e) {
    case "top":
      return te("calc(50%)", "calc(100%)", r, n);
    case "top-start":
      return te("calc(12px)", "calc(100%)", r, n);
    case "top-end":
      return te("calc(100% - 12px)", "calc(100%)", r, n);
    case "bottom":
      return te("calc(50%)", "0px", r, n);
    case "bottom-start":
      return te("calc(12px)", "0px", r, n);
    case "bottom-end":
      return te("calc(100% - 12px)", "0px", r, n);
    case "left":
      return te("calc(100%)", "calc(50%)", r, n);
    case "left-start":
      return te("calc(100%)", "calc(12px)", r, n);
    case "left-end":
      return te("calc(100%)", "calc(100% - 12px)", r, n);
    case "right":
      return te("0px", "calc(50%)", r, n);
    case "right-start":
      return te("0px", "calc(12px)", r, n);
    case "right-end":
      return te("0px", "calc(100% - 12px)", r, n);
  }
}
const Ta = V`
  font-size: 14px;
`;
function tt(e) {
  return V`
    display: inline-flex;
    flex-direction: column;
    width: ${e ? "100%" : "auto"};
  `;
}
function nt(e) {
  return V`
    display: inline-flex;
    flex-direction: row;
    width: ${e ? "100%" : "auto"};
  `;
}
const Oa = rr({
  title: "TriangleIconTop",
  viewBox: "0 0 8 4",
  d: "M8 0H0L3.29289 3.29289C3.68342 3.68342 4.31658 3.68342 4.70711 3.29289L8 0Z"
}), Pa = rr({
  title: "TriangleIconBottom",
  viewBox: "0 0 8 4",
  d: "M8 4H0L3.29289 0.707107C3.68342 0.316583 4.31658 0.316583 4.70711 0.707107L8 4Z"
}), Na = rr({
  title: "TriangleIconLeft",
  viewBox: "0 0 4 8",
  d: "M0 8V0L3.29289 3.29289C3.68342 3.68342 3.68342 4.31658 3.29289 4.70711L0 8Z"
}), $a = rr({
  title: "TriangleIconRight",
  viewBox: "0 0 4 8",
  d: "M4.00098 8V0L0.707366 3.29281C0.316726 3.68335 0.316726 4.31665 0.707366 4.70719L4.00098 8Z"
}), Rr = Wt({
  renderInBody: !0,
  zIndex: 1
});
Rr.displayName = "TriggerProviderContext";
const ka = (e) => {
  const { onBlur: r, onFocus: n, triggerRef: a, children: o, closeWhenScroll: i = !0, autoFitPosition: l = !0, colorScheme: u = "gray", clickOutsideToClose: p = !0, content: h, closeOnInnerClick: d, position: g = "top", showArrow: R = !0, closeDelay: A = 150, openDelay: k = 150, autoAlignPopupWidth: m, closeOnClick: F = !0, defaultPopupVisible: x, withoutPadding: b, withoutShadow: C, withoutOffset: I, disabled: c, popupVisible: M, maxW: _ = "566px", onVisibleChange: K, trigger: oe = "hover", alignPoint: Ee, renderInBody: ke, zIndex: xe, popupContainer: W } = e, Z = jr(null), [le, ie] = zt(!1), se = M === void 0 ? le : M, ve = ot(Rr), _e = ke ?? ve.renderInBody ?? !0, me = xe ?? ve.zIndex ?? 1;
  let Se = (W instanceof HTMLElement ? W : W == null ? void 0 : W.current) ?? (_e ? document.body : null);
  Ut(() => {
    x && M === void 0 && ie(!0);
  }, []);
  const he = Bt(() => {
    let w = [];
    return l && w.push(Zt()), I || w.push(Jt(4)), m && w.push(Kt({
      apply({ availableWidth: be, availableHeight: wr, elements: ir }) {
        var we;
        Object.assign(ir.floating.style, {
          width: `${(we = U.current) == null ? void 0 : we.clientWidth}px`
        });
      }
    })), w.push(Qt()), w;
  }, [l, I, m]), { x: Ce, y: Ae, reference: Ie, floating: ye, strategy: ge, placement: q, context: ne, elements: H } = en({
    placement: g,
    open: se,
    onOpenChange: (w) => {
      !c && se !== w && (M === void 0 && ie(w), K == null || K(w));
    },
    middleware: he,
    whileElementsMounted: rn
  }), { getReferenceProps: De, getFloatingProps: v } = tn([
    nn(ne, {
      enabled: oe === "hover",
      move: !0,
      restMs: 200,
      delay: {
        open: k,
        close: A
      },
      handleClose: an({
        restMs: 200,
        buffer: 1
      })
    }),
    on(ne, {
      enabled: oe === "click",
      toggle: F
    }),
    sn(ne, {
      enabled: oe === "focus",
      keyboardOnly: !1
    }),
    cn(ne, { role: "tooltip" }),
    un(ne, {
      outsidePress: p,
      ancestorScroll: i
    })
  ]), ce = G("div", { css: Ta, children: h }), U = jr(null);
  let Q = G(rt, {});
  switch (q) {
    case "top":
    case "top-start":
    case "top-end":
      Q = Le("div", { css: tt(m), children: [G("div", { ref: Z, css: Xe(u, _, b, C, m), children: ce }), R && G(Oa, { w: "8px", h: "4px", containerStyle: Ge(u, q) })] });
      break;
    case "bottom":
    case "bottom-start":
    case "bottom-end":
      Q = Le("div", { css: tt(m), children: [R && G(Pa, { w: "8px", h: "4px", containerStyle: Ge(u, q) }), G("div", { ref: Z, css: Xe(u, _, b, C, m), children: ce })] });
      break;
    case "right":
    case "right-start":
    case "right-end":
      Q = Le("div", { css: nt(m), children: [R && G($a, { w: "4px", h: "8px", containerStyle: Ge(u, q) }), G("div", { ref: Z, css: Xe(u, _, b, C, m), children: ce })] });
      break;
    case "left":
    case "left-start":
    case "left-end":
      Q = Le("div", { css: nt(m), children: [G("div", { ref: Z, css: Xe(u, _, b, C, m), children: ce }), R && G(Na, { w: "4px", h: "8px", containerStyle: Ge(u, q) })] });
      break;
  }
  const Re = G(pn.div, { css: Ra(m), variants: wa(q, R), initial: "initial", animate: "animate", exit: "exit", children: Q }), qe = fn([
    Ie,
    e.children.ref,
    U
  ]);
  return qt(a, () => ({
    rerenderPosition: () => {
      H.reference && H.floating && ln(H.reference, H.floating, {
        placement: q,
        middleware: he
      }).then(({ x: w, y: be }) => {
        H.floating && Object.assign(H.floating.style, {
          left: `${w}px`,
          top: `${be}px`
        });
      });
    }
  }), [H.floating, H.reference, he, q]), Le(rt, { children: [Ht(o, De({
    key: "illa-trigger",
    ...o.props,
    ref: qe,
    onContextMenu: (w) => {
      c || (o.props.onContextMenu != null && o.props.onContextMenu(w), oe === "contextmenu" && (w.preventDefault(), Ee && U.current != null && Object.assign(U.current, {
        getBoundingClientRect: () => ({
          x: w.clientX,
          y: w.clientY,
          width: 0,
          height: 0,
          top: w.clientY,
          right: w.clientX,
          bottom: w.clientY,
          left: w.clientX
        })
      }), M === void 0 ? ie(!se) : K == null || K(!se)));
    },
    onClick: (w) => {
      o.props.onClick != null && o.props.onClick(w), Ee && oe === "click" && U.current != null && Object.assign(U.current, {
        getBoundingClientRect: () => ({
          x: w.clientX,
          y: w.clientY,
          width: 0,
          height: 0,
          top: w.clientY,
          right: w.clientX,
          bottom: w.clientY,
          left: w.clientX
        })
      });
    }
  })), G(dn, { root: Se ?? (U == null ? void 0 : U.current) ?? document.body, children: !c && G(vn, { children: se && G("div", { onFocus: n, onBlur: r, css: [
    V`
                    display: inline-flex;
                    z-index: ${me};
                  `,
    Gt(e)
  ], ...v({
    onClick: (w) => {
      d && (M === void 0 ? ie(!1) : K == null || K(!1));
    },
    ref: ye,
    style: {
      position: ge,
      top: Ae ?? 0,
      left: Ce ?? 0
    }
  }), children: Re }) }) })] });
};
ka.displayName = "Trigger";
const Aa = (e) => {
  const { renderInBody: r, zIndex: n } = e;
  return G(Rr.Provider, { value: { renderInBody: r, zIndex: n }, children: e.children });
};
Aa.displayName = "TriggerProvider";
export {
  ka as Trigger,
  Aa as TriggerProvider,
  Rr as TriggerProviderContext
};
//# sourceMappingURL=index.js.map
